export const Page = {
  NEST: "NEST",
  AIC: "AIC",
} as const;
export type Page = (typeof Page)[keyof typeof Page];
